import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    events: {
        'click .import': 'onImport'
    },

    dom_handlers: {
        onImport: function(e) {
            Modals.feedbackCsvImport(this.model);
        },
    },

    render: function() {
        var content = '';

        content +=
        '<div class="box padding-32">' +
            '<div class="grid-8-4 grid-none-mobile">' +
                '<div>' +
                    '<h3>' +
                        '<span class="v-align-middle">Import from CSV</span>' +
                    '</h3>' +
                    '<div class="text-info text-medium">Import ideas from other sources to your ideas portal. <a class="text-info" href="https://support.userback.io/en/articles/6102051-getting-started-with-your-feedback-portal-and-configuring-portal-settings" target="help" rel="noopener">Learn more</a>.</div>' +
                '</div>' +
                '<div class="text-align-right">' +
                    '<button type="button" class="import primary small">Import from CSV</button>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        return this;
    }
});